import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';
import { initialize, logout, selectAccount } from './auth.actions';
import { AuthService } from './auth.service';

export const initializeEffect: ReturnType<typeof createEffect> = createEffect(
  (actions$ = inject(Actions), authService = inject(AuthService)) => {
    return actions$.pipe(
      ofType(initialize),
      tap(() => {
        authService.initialize();
      })
    );
  },
  { functional: true, dispatch: false }
);

export const selectAccountEffect: ReturnType<typeof createEffect> = createEffect(
  (actions$ = inject(Actions), authService = inject(AuthService)) => {
    return actions$.pipe(
      ofType(selectAccount),
      tap((action) => {
        authService.selectUser(action.account);
      })
    );
  },
  { functional: true, dispatch: false }
);

export const logoutEffect: ReturnType<typeof createEffect> = createEffect(
  (actions$ = inject(Actions), authService = inject(AuthService)) => {
    return actions$.pipe(
      ofType(logout),
      tap(() => {
        authService.logout();
      })
    );
  },
  { functional: true, dispatch: false }
);

export const allAuthEffects: object = { initializeEffect, selectAccountEffect, logoutEffect };
